<!-- background -->
<rid-mechanic-background />

<rid-mechanic-wrapper>
  <!-- top-bar -->
  <rid-top-bar class="block w-full" name="Leeslijst | Categoriseren" [steps]="1" [progress]="state().type === 'FEEDBACK' ? 1 : 0" />

  <rid-mechanic-content>
    <!-- title -->
    @if (state().type === 'SELECTING') {
      <rid-mechanic-title [title]="'Tik op de woorden die in de categorie passen'" />
    }

    <div class="flex flex-col gap-8">
      <!-- category -->
      <rid-content-card
        #categoryCard
        class="self-center"
        layout="HORIZONTAL"
        [text]="category()"
        [audio]="{ pronounce: category() }"
        animate.enter="wait-500 anim-pop-in"
        ridSfx="BUBBLE_POP"
        (animationend)="$event.animationName === 'pop-in' ? onCategoryPoppedIn() : undefined"
      />

      <!-- matrix -->
      <rid-word-matrix class="block self-center" [matrix]="matrixWithAppearance()" (selectionChanged)="onSelectionChanged($event)" />
    </div>

    <!-- ready button -->
    @if (state().type === 'SELECTING' && selection().length > 0) {
      <rid-bottom-button content="Klaar!" (clicked)="evaluate()" />
    }
    @if (state().type === 'FEEDBACK') {
      <rid-bottom-button class="wait-500" content="Volgende" (clicked)="finish()" />
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
